import script from "./NotasTableSkeleton.vue?vue&type=script&setup=true&lang=js"
export * from "./NotasTableSkeleton.vue?vue&type=script&setup=true&lang=js"

import "./NotasTableSkeleton.vue?vue&type=style&index=0&id=9988cc42&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9988cc42"]])

export default __exports__